import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const ContactPage = () => {
  const navigate = useNavigate();
  const [copied, setCopied] = useState('');

  const copy = (text, key) => {
    navigator.clipboard.writeText(text);
    setCopied(key);
    setTimeout(() => setCopied(''), 2000);
  };

  const contacts = [
    { key: 'general', label: 'General Inquiries', email: 'hello@eventdeck.app', desc: 'Questions about EventDeck, partnerships, and general information.' },
    { key: 'support', label: 'Participant Support', email: 'support@eventdeck.app', desc: 'Help with registrations, tickets, QR codes, and account issues.' },
    { key: 'organiser', label: 'Organiser Support', email: 'organisers@eventdeck.app', desc: 'Help with portal setup, payment config, and event management.' },
    { key: 'refund', label: 'Refund Disputes', email: 'refunds@eventdeck.app', desc: 'Escalate unresolved refund issues with event organisers.' },
    { key: 'legal', label: 'Legal & Privacy', email: 'legal@eventdeck.app', desc: 'Privacy requests, GDPR inquiries, and legal matters.' },
    { key: 'security', label: 'Security', email: 'security@eventdeck.app', desc: 'Report vulnerabilities, fraud, or security concerns.' },
  ];

  return (
    <div className="min-h-screen bg-[#050505] text-white">
      <nav className="fixed top-0 w-full z-50 bg-black/70 backdrop-blur-xl border-b border-white/[0.05]">
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-4 flex justify-between items-center">
          <div className="flex items-center gap-2 cursor-pointer" onClick={() => navigate('/')}>
            <img
              src="/logo192.png"
              alt="EventDeck"
              className="w-10 h-10 object-contain"
            />
            <h1 className="text-lg font-black tracking-tighter uppercase">EVENT<span className="text-sky-500">DECK</span></h1>
          </div>
          <button onClick={() => navigate(-1)} className="text-[10px] font-black text-gray-500 hover:text-white uppercase tracking-widest transition-colors">← Back</button>
        </div>
      </nav>

      <main className="max-w-4xl mx-auto px-4 md:px-6 pt-32 pb-24">
        <div className="mb-12">
          <p className="text-[9px] font-black text-sky-500 uppercase tracking-[0.4em] mb-2">Get In Touch</p>
          <h1 className="text-4xl font-black uppercase tracking-tighter mb-3">Contact Us</h1>
          <p className="text-gray-400 text-sm max-w-lg">We're here to help. Choose the right team below for the fastest response.</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-16">
          {contacts.map(c => (
            <div key={c.key} className="bg-white/[0.02] border border-white/[0.07] rounded-2xl p-5 hover:border-sky-500/20 transition-all">
              <p className="text-[9px] font-black text-sky-500 uppercase tracking-widest mb-1">{c.label}</p>
              <div className="flex items-center justify-between gap-2 mb-2">
                <p className="text-sm font-black text-white">{c.email}</p>
                <button onClick={() => copy(c.email, c.key)}
                  className={`text-[9px] font-black uppercase px-2.5 py-1 rounded-lg transition-all ${copied === c.key ? 'bg-emerald-500 text-white' : 'bg-white/5 text-gray-500 hover:text-white border border-white/10'}`}>
                  {copied === c.key ? '✓' : 'Copy'}
                </button>
              </div>
              <p className="text-gray-500 text-xs leading-relaxed">{c.desc}</p>
            </div>
          ))}
        </div>

        <div className="bg-white/[0.02] border border-white/[0.07] rounded-3xl p-8 mb-10">
          <h2 className="text-xl font-black uppercase tracking-tight mb-6">Response Times</h2>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-5">
            {[
              { time: '< 2 hrs', label: 'Security Issues', color: 'text-red-400' },
              { time: '< 24 hrs', label: 'Participant Support', color: 'text-sky-400' },
              { time: '< 48 hrs', label: 'General Inquiries', color: 'text-gray-400' },
            ].map(r => (
              <div key={r.label} className="text-center p-4 bg-black/40 rounded-2xl border border-white/[0.05]">
                <p className={`text-2xl font-black ${r.color} mb-1`}>{r.time}</p>
                <p className="text-[10px] text-gray-500 uppercase font-bold tracking-widest">{r.label}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="bg-sky-500/5 border border-sky-500/20 rounded-2xl p-6">
          <p className="text-[9px] font-black text-sky-500 uppercase tracking-widest mb-2">For Event Organisers</p>
          <p className="text-sm text-gray-400 leading-relaxed">If you're an event organiser experiencing issues with a specific registration, please include the participant's name, email, and transaction ID in your message for faster resolution.</p>
        </div>
      </main>
    </div>
  );
};

export default ContactPage;